import { render } from "./GiftCardsStore.vue?vue&type=template&id=542b6e4d&scoped=true"
import script from "./GiftCardsStore.vue?vue&type=script&lang=js"
export * from "./GiftCardsStore.vue?vue&type=script&lang=js"

import "./GiftCardsStore.vue?vue&type=style&index=0&id=542b6e4d&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542b6e4d"]])

export default __exports__